export const imageDownload = (image, name) => {
  let a = document.createElement("a");
  a.href = `data:image/jpeg;base64,${image}`;
  a.download = name;
  a.click();
};
